import Routes from 'Routes';
// import { gspCollect } from '@csair/emp-helpers';
export default store => ({
  path: Routes.ticket.child.changeFlight.key,
  onEnter(nextState, replace, callback) {
    // gspCollect(
    //   [
    //     '2021-EMP退改-退票提交申请页面',
    //     '退票提交申请页面',
    //     '006-000-71001-103',
    //   ],
    //   { 6: '国内' },
    //   process.env.NODE_ENV === 'production'
    // );
    callback();
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const changeFlight = require('./components/ChangeFlight').default;
        cb(null, changeFlight);
      },
      'changeFlight'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/changeFlight/index.js